import { Cell, flexRender, Row } from '@tanstack/react-table';
import classNames from 'classnames';
import { memo, MouseEvent } from 'react';
import { NATIVE_COLUMNS } from '@components/primitives/dataGrid/DataGrid';

interface Props<TData> {
    cell: Cell<TData, unknown>;
    row: Row<TData>;
    isSelected: boolean;
    onCellClick?: (row: Row<TData>, columnId: keyof TData) => void;
}

const DataGridCell = <TData extends object>({ cell, row, isSelected, onCellClick }: Props<TData>) => {
    const handleClick = (e: MouseEvent<HTMLDivElement>) => {
        if (!onCellClick || NATIVE_COLUMNS.includes(cell.column.id) || !(e.target instanceof HTMLDivElement || e.target instanceof HTMLSpanElement)) {
            return;
        }

        onCellClick(row, cell.column.id as keyof TData);
    };

    return (
        <div
            key={cell.id}
            style={{
                width: cell.column.getSize(),
            }}
            className={classNames('dataGrid__cell', cell.column.columnDef.meta?.className, {
                'dataGrid__cell--active': isSelected,
            })}
            onClick={handleClick}
        >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </div>
    );
};

export default memo(DataGridCell) as typeof DataGridCell;
